package fyi.moko.hotpl.ui.theme

import androidx.compose.ui.graphics.Color
import fyi.moko.hotpl.domain.model.Emotion

/**
 * The palette's deterministic color per emotion — rendered as the small "color dot"
 * on a place card (the emotion channel, distinct from the visit-frequency glow).
 * Hex values match the reviewed palette in EMOTION_TAGS_RESEARCH.md, except Lively.
 *
 * ── Lively가 빨강이 아닌 이유 (2026-09-10) ──────────────────────────────
 * 리뷰어 결정으로 지도의 기본 핀(감정 없는 장소)이 구글 마커의 빨강을 쓴다(백로그 0-26).
 * 원래 팔레트의 Lively 빨강(#E24B4A)은 그것과 구별이 안 되므로 노랑으로 옮겼다 —
 * 팔레트에 없던 색이고 "활기"와도 맞는다. 카드의 점도 같이 바뀐다.
 */
val Emotion.dotColor: Color
    get() = when (this) {
        Emotion.LIVELY -> Color(0xFFE9B800)
        Emotion.ADVENTUROUS -> Color(0xFFD85A30)
        Emotion.COZY -> Color(0xFFBA7517)
        Emotion.AT_EASE -> Color(0xFF639922)
        Emotion.SERENE -> Color(0xFF1D9E75)
        Emotion.RESTORED -> Color(0xFF378ADD)
        Emotion.AWE -> Color(0xFF7F77DD)
        Emotion.WISTFUL -> Color(0xFFD4537E)
    }
